export default "__VITE_ASSET__CPz9W_sA__"